import React from 'react';
import classNames from 'classnames';
import { getThemeConfig } from 'Sites/themes';
import styles from './SiteThemeIcon.module.css';
import { SentryApiClient } from '_generated/api';

export interface SiteThemeIconProps {
  /** The theme type to display. Returns null for Default theme. */
  theme: SentryApiClient.UIThemeType;
  /** Render a smaller version of the icon */
  small?: boolean;
}

/**
 * Renders a circular icon with the theme's primary color background
 * and the corresponding theme icon image.
 *
 * For Default theme, this component returns null - use LetterIcon instead.
 */
export const SiteThemeIcon: React.FC<SiteThemeIconProps> = ({
  theme,
  small,
}) => {
  const config = getThemeConfig(theme);

  // Don't render for Default theme
  if (!config) {
    return null;
  }

  return (
    <div
      className={classNames(styles.icon, { [styles.small]: small })}
      style={
        {
          '--theme-icon-bg-color': config.colors.primary,
        } as React.CSSProperties
      }
    >
      <img
        src={config.iconPath}
        alt={config.name}
        className={styles.iconImage}
      />
    </div>
  );
};
